// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-button[data-v-5477d6c2]{display:flex;align-items:center;gap:calc(2*var(--default-grid-baseline))}`, "",{"version":3,"sources":["webpack://./src/components/ConversationSettings/NotificationsSettings.vue"],"names":[],"mappings":"AACA,+BACC,YAAA,CACA,kBAAA,CACA,wCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
